
<div class="container-fluid text-center mt-5">
  <div class="row justify-content-center">
    <div class="col-12 col-md-12">
      <div class="alert alert-success p-4">
        <i class="bi bi-check-circle-fill icon-style"></i>
        <p style=" font-weight: bold; font-size: 17px;">
          Thank You for uploading
          documents to New York State Department of Labor Unemployment Insurance
          Employer Services Audit Unit. Confirmation Number:
        </p>
        <p style=" font-weight: bold; font-size: 17px;"> {{ confimationNumber}}</p>
        <button type="submit" class="btn btn-primary mt-2" (click)="goBack()">
          <i class="bi bi-house">
            Go Back
          </i>
        </button>
      </div>
    </div>
  </div>
</div>
